export const RestoreDestinationsIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ flexShrink: 0 }}
  >
    <path
      d='M11.5 19V14H13V15.75H19V17.25H13V19H11.5ZM5 17.25V15.75H10V17.25H5ZM8 14.5V12.75H5V11.25H8V9.5H9.5V14.5H8ZM11 12.75V11.25H19V12.75H11ZM14 10V5H15.5V6.75H19V8.25H15.5V10H14ZM5 8.25V6.75H13V8.25H5Z'
      fill='currentColor'
    />
  </svg>
);
